module.exports = __webpack_public_path__ + "img/vehicle-options-black-cjdr.2da497af.jpg";